const comment = {
  state: () => ({
    boxCommentData: null,
    controlbarIconList: null,
    displayingCommentList: null,
    commentList: null,
    isBoxDrawn: false,
    clickcmId: {},
    isFadeOut: false,
    isEmojiFadeOut: false,
    isGuestVisible: false,
    commentPlayOn: false,
    commentPlayTimeOutValue: 0,
    commentPlayPreview: true,
    emojiPlayPreview: false,
    emojiPlayOn: true,
    clickEmojiId: {},
    emoticonList: null,
    feedbackEmoji: null,
    serverCommu: false,
    showEmojiPlay: false,
    filteredDisplayingEmojiList: false,
    isCommentIconClicked: null,
  }),

  mutations: {
    setBoxCommentData(state, payload) {
      state.boxCommentData = payload
    },
    setControlbarIconList(state, controlbarIconList) {
      state.controlbarIconList = controlbarIconList
    },
    setDisplayingCommentList(state, displayingCommentList) {
      state.setDisplayingCommentList = displayingCommentList
    },
    setCommentList(state, commentList) {
      state.commentList = commentList
    },

    setBoxDrawn(state, payload) {
      state.isBoxDrawn = payload
    },

    setClickcmId(state, payload) {
      state.clickcmId = payload
    },

    setIsFadeOut(state, payload) {
      state.isFadeOut = payload
    },

    setIsEmojiFadeOut(state, payload) {
      state.isEmojiFadeOut = payload
    },
    setIsGuestVisible(state, payload) {
      state.isGuestVisible = payload
    },
    setCommentPlayOn(state, payload) {
      state.commentPlayOn = payload
    },
    setCommentPlayTimeOutValue(state, payload) {
      state.commentPlayTimeOutValue = payload
    },
    setCommentPlayPreview(state, payload) {
      state.commentPlayPreview = payload
    },
    setEmojiPlayPreview(state, payload) {
      state.emojiPlayPreview = payload
    },
    setEmojiPlayOn(state, payload) {
      state.emojiPlayOn = payload
    },

    setClickEmojiId(state, payload) {
      state.clickEmojiId = payload
    },
    setEmoticonList(state, payload) {
      state.emoticonList = payload
    },
    setFeedbackEmoji(state, payload) {
      state.feedbackEmoji = payload
    },
    setServerCommu(state, payload) {
      state.serverCommu = payload
    },
    setShowEmojiPlay(state, payload) {
      state.showEmojiPlay = payload
    },
    setFilteredDisplayingEmojiList(state, payload) {
      state.filteredDisplayingEmojiList = payload
    },

    setIsCommentIconClicked(state, payload) {
      state.isCommentIconClicked = payload
    },
  },

  actions: {
    setBoxCommentData({ commit }, payload) {
      commit('setBoxCommentData', payload)
    },
    setControlbarIconList({ commit }, controlbarIconList) {
      commit('setControlbarIconList', controlbarIconList)
    },

    setDisplayingCommentList({ commit }, displayingCommentList) {
      commit('setControlbarIconList', displayingCommentList)
    },

    setCommentList({ commit }, commentList) {
      commit('setCommentList', commentList)
    },

    setBoxDrawn({ commit }, payload) {
      commit('setBoxDrawn', payload)
    },

    setClickcmId({ commit }, payload) {
      commit('setClickcmId', payload)
    },

    setIsFadeOut({ commit }, payload) {
      commit('setIsFadeOut', payload)
    },
    setIsEmojiFadeOut({ commit }, payload) {
      commit('setIsEmojiFadeOut', payload)
    },
    setCommentPlayOn({ commit }, payload) {
      commit('setCommentPlayOn', payload)
    },
    setCommentPlayTimeOutValue({ commit }, payload) {
      commit('setCommentPlayTimeOutValue', payload)
    },
    setCommentPlayPreview({ commit }, payload) {
      commit('setCommentPlayPreview', payload)
    },
    setEmojiPlayPreview({ commit }, payload) {
      commit('setEmojiPlayPreview', payload)
    },

    setEmojiPlayOn({ commit }, payload) {
      commit('setEmojiPlayOn', payload)
    },

    setClickEmojiId({ commit }, payload) {
      commit('setClickEmojiId', payload)
    },

    setEmoticonList({ commit }, payload) {
      commit('setEmoticonList', payload)
    },

    setFeedbackEmoji({ commit }, payload) {
      commit('setFeedbackEmoji', payload)
    },
    setServerCommu({ commit }, payload) {
      commit('setServerCommu', payload)
    },
    setIsGuestVisible({ commit }, payload) {
      commit('setIsGuestVisible', payload)
    },
    setShowEmojiPlay({ commit }, payload) {
      commit('setShowEmojiPlay', payload)
    },
    setFilteredDisplayingEmojiList({ commit }, payload) {
      commit('setFilteredDisplayingEmojiList', payload)
    },

    setIsCommentIconClicked({ commit }, payload) {
      commit('setIsCommentIconClicked', payload)
    },
  },

  getters: {
    boxCommentData(state) {
      return state.boxCommentData
    },
    controlbarIconList(state) {
      return state.controlbarIconList
    },

    displayingCommentList(state) {
      return state.displayingCommentList
    },

    commentList(state) {
      let list = state.commentList
      return list !== undefined && list !== null && list.length > 0 ? list : []
    },

    boxDrawn(state) {
      return state.isBoxDrawn
    },

    clickCommentId(state) {
      return state.clickcmId
    },

    isFadeOut(state) {
      return state.isFadeOut
    },

    isEmojiFadeOut(state) {
      return state.isEmojiFadeOut
    },

    isGuestVisible(state) {
      return state.isGuestVisible
    },

    isCommentPlayOn(state) {
      return state.commentPlayOn
    },

    removeCommentPlayTimeOut(state) {
      return state.commentPlayTimeOutValue
    },

    commentPlayPreview(state) {
      return state.commentPlayPreview
    },

    emojiPlayPreview(state) {
      return state.emojiPlayPreview
    },

    emojiPlayOn(state) {
      return state.emojiPlayOn
    },

    clickEmojiId(state) {
      return state.clickEmojiId
    },

    emoticonList(state) {
      return state.emoticonList
    },

    feedbackEmoji(state) {
      return state.feedbackEmoji
    },

    serverCommu(state) {
      return state.serverCommu
    },
    computedEmojiPlay(state) {
      return state.showEmojiPlay
    },

    filteredDisplayingEmojiList(state) {
      return state.filteredDisplayingEmojiList
    },

    isCommentIconClicked(state) {
      return state.isCommentIconClicked
    },
  },
}

export default comment
